import React from "react";
import { Box, Divider, Typography } from "@mui/material";
import { FORM_MODAL_HEADER_SX, FORM_MODAL_TITLE_SX, FORM_DIVIDER_SX } from "../utils/formModalStyles";

/**
 * Form/dialog title with spacing + horizontal rule (header separator).
 */
const FormModalHeader = ({ title, subtitle, sx = {} }) => {
  if (!title) return null;

  return (
    <Box sx={{ ...FORM_MODAL_HEADER_SX, ...sx }}>
      <Typography component="h2" sx={FORM_MODAL_TITLE_SX}>
        {title}
      </Typography>
      {subtitle ? (
        <Typography
          variant="body2"
          color="text.secondary"
          textAlign="center"
          sx={{ fontSize: "0.8rem", mb: 0.5, mt: -0.25 }}
        >
          {subtitle}
        </Typography>
      ) : null}
      <Divider sx={FORM_DIVIDER_SX} />
    </Box>
  );
};

export default FormModalHeader;
